<top-bar-filters
  [reactiveForm]="filtersForm"
  [formLayoutConfig]="filtersLayoutConfig"
  [formControlsConfigMap]="filtersConfigMap"
  [valuesMap]="valuesMap"
  (updateValuesMap)="updateValuesMap($event)"
  (onApply)="applyFilters()"
  (onClear)="clearFilters()"
>
</top-bar-filters>

@if (error) {
  <div class="var__error">{{ error }}</div>
}

@if (loading) {
  <div class="loading__message d-flex align-items-center">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="loading__message-text ml-3">Loading real-time data, please wait…</span>
  </div>
}

@if (summary && !loading) {
  <div class="var__card var__top-card">
    <div class="var__card-header">
      <span class="var__chart-title">Tickets Varience by Date</span>
      <div class="var__inline-legend">
        <span class="var__legend-dot" style="background: #64b5f6"></span>
        <span class="var__legend-label">Entered</span>
        <span class="var__legend-dot var__legend-dot--closed"></span>
        <span class="var__legend-label">Closed</span>
      </div>
    </div>
    <div class="var__chart-wrapper var__chart-wrapper--tall">
      <canvas
        baseChart
        [type]="'bar'"
        [data]="monthlyChartData"
        [options]="groupedBarOptions"
        [plugins]="monthlyChartPlugins"
      ></canvas>
    </div>
  </div>

  <div class="var__card var__bottom-card d-flex">
    <div class="var__left-col d-flex flex-column">
      <div class="var__chart-wrapper var__chart-wrapper--hourly">
        <canvas
          baseChart
          [type]="'bar'"
          [data]="hourEnteredChartData"
          [options]="hourEnteredBarOptions"
          [plugins]="hourlyChartPlugins"
        ></canvas>
      </div>
      <div class="var__chart-wrapper var__chart-wrapper--hourly">
        <canvas
          baseChart
          [type]="'bar'"
          [data]="hourClosedChartData"
          [options]="hourClosedBarOptions"
          [plugins]="hourlyChartPlugins"
        ></canvas>
      </div>
    </div>

    <div class="var__right-col">
      @if (loadingTickets) {
        <div class="d-flex justify-content-center align-items-center" style="min-height: 100px">
          <mat-spinner [diameter]="28"></mat-spinner>
        </div>
      }
      @if (ticketPageData && !loadingTickets) {
        <div class="var__table">
          <div class="var__table-scroll">
            <table mat-table [dataSource]="ticketPageData.data" class="udt-table w-100">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>Ticket #</th>
                <td mat-cell *matCellDef="let row">
                  <a class="var__ticket-link" [routerLink]="['/secured/managed-services/tickets', row.id]">{{
                    row.id
                  }}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="dateEntered">
                <th mat-header-cell *matHeaderCellDef>Date Entered</th>
                <td mat-cell *matCellDef="let row">{{ row.dateEntered | hubDate }}</td>
              </ng-container>
              <ng-container matColumnDef="closedDate">
                <th mat-header-cell *matHeaderCellDef>Date Closed</th>
                <td mat-cell *matCellDef="let row">{{ row.closedDate ? (row.closedDate | hubDate) : '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let row">{{ row.contactName ?? '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="summary">
                <th mat-header-cell *matHeaderCellDef>Summary</th>
                <td mat-cell *matCellDef="let row" class="var__summary-cell">{{ row.summary }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <mat-paginator
            [length]="ticketPageData.total"
            [pageSize]="pageSize"
            [pageIndex]="currentPage - 1"
            [pageSizeOptions]="[25, 50, 100, 200]"
            showFirstLastButtons
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      }
    </div>
  </div>
}
